const schema = require('./runtime-config.schema.json')

let cachedConfig

function validateRuntimeConfig(config) {
  if (!config || typeof config !== 'object' || Array.isArray(config)) {
    return ['config must be an object']
  }

  const errors = []
  const supportedFields = new Set(['schemaVersion', 'environment'])
  for (const key of Object.keys(config)) {
    if (!supportedFields.has(key)) errors.push(`${key} is not supported`)
  }
  if (config.schemaVersion !== schema.schemaVersion) {
    errors.push(`schemaVersion must be ${schema.schemaVersion}`)
  }
  if (!schema.environments.includes(config.environment)) {
    errors.push(`environment must be one of: ${schema.environments.join(', ')}`)
  }
  return errors
}

function getRuntimeConfig() {
  if (cachedConfig) return cachedConfig
  if (typeof window === 'undefined') throw new Error('qiepian portal runtime config requires a browser')

  const loadError = window.__QIEPIAN_PORTAL_CONFIG_LOAD_ERROR__
  if (loadError) throw new Error(`qiepian portal runtime config load failed: ${loadError}`)

  const config = window[schema.globalName]
  const errors = validateRuntimeConfig(config)
  if (errors.length > 0) throw new Error(`invalid qiepian portal runtime config: ${errors.join('; ')}`)
  cachedConfig = Object.freeze({ ...config })
  return cachedConfig
}

module.exports = { getRuntimeConfig, validateRuntimeConfig }
